export default "__VITE_ASSET__d1f77802__"